import { render, staticRenderFns } from "./Atributos.vue?vue&type=template&id=f2418d02&scoped=true"
import script from "./Atributos.vue?vue&type=script&lang=js"
export * from "./Atributos.vue?vue&type=script&lang=js"
import style0 from "./Atributos.vue?vue&type=style&index=0&id=f2418d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2418d02",
  null
  
)

export default component.exports